import { get, groupBy, isNil, map, mapKeys, orderBy, toPairs } from 'lodash';
import React from 'react'
import { Accordion } from 'react-bootstrap';
import Icon from 'UI/FontAwesomeIcon'
import VulnerabilitiesAccordionTable from './VulnerabilitiesAccordionTable';
import { severityColor } from './Helper';

const VulnerabilityAccordion = ({ vulnerabilities }) => {
  return (
    map(Object.entries(vulnerabilities), ([severity, vulnerabilitiesArray]) => (
      <Accordion flush>
        <Accordion.Item eventKey={severity}>
          <Accordion.Header>
            <Icon icon='arrow-alt-circle-up' style={{ color: severityColor(severity) }} className="pr-3 text-2xl" />
            <span className='text-xl'>Severity: {severity} ({vulnerabilitiesArray.length})</span>
          </Accordion.Header>
          <Accordion.Body>
            <VulnerabilitiesAccordionTable vulnerabilities={vulnerabilitiesArray} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    ))
  )
}

export default VulnerabilityAccordion